export class CreateUserRequest{
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    Role: string;
    ClientID: number;
    IsActive: boolean;
}